import Util from "../Classes/Util";

export const Variables = {
  API_URL: "https://api.homedepotoflebanon.com/api/",
  imagePath: "https://api.homedepotoflebanon.com/Upload/",
  // API_URL: "http://localhost:5000/api/",
  // imagePath: "http://localhost:5000/Upload/",


  // API_URL: "https://localhost:5001/api/",
 // API_URL: "http://localhost:44342/api/",

};
